import React from 'react';

const IconComp = ({ icon, classes }) => {
  return <span className={`icon-comp ${classes || ''}`}>{icon}</span>;
};

export default IconComp;
